import { render, staticRenderFns } from "./CourseStopAdmission.vue?vue&type=template&id=f00c46a8&scoped=true&"
import script from "./CourseStopAdmission.vue?vue&type=script&lang=js&"
export * from "./CourseStopAdmission.vue?vue&type=script&lang=js&"
import style0 from "./CourseStopAdmission.vue?vue&type=style&index=0&id=f00c46a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00c46a8",
  null
  
)

export default component.exports